import React from 'react';
import { FiCheck } from "react-icons/fi";

const AboutFour = ({ image }) => {
    return (
        <div className="about-area about-style-4 rn-section-gap">
            <div className="container">
                <div className="row row--40 align-items-center">
                    <div className="col-lg-6">
                        <div className="service gallery-style text-start home-section-image-card">
                            <div className="inner">
                                <div className="image">
                                    <img
                                        src={image}
                                        alt="Jaz Infotech custom software development team in Tirunelveli"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt_md--40 mt_sm--40">
                        <div className="content">
                            <div className="inner">
                                <h3 className="title">Custom Software & Mobile App Development Company in Tirunelveli</h3>
                                <ul className="feature-list">
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <h4 className="title">Custom Software Development</h4>
                                            <p className="text">We design and build tailored software — ERP, CRM, billing systems, and business tools that fit how you work.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <h4 className="title">Mobile App Development</h4>
                                            <p className="text">Android and iOS apps with modern UI, solid performance, and features your users actually need.</p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="about-btn mt--30">
                                    <a className="btn-default" href="/about-us">About Jaz Infotech</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutFour
